import React, { useEffect, useState } from "react";
import api from "../../api";
import { useNavigate } from "react-router-dom";

const StudentFeedback = ({ sid }) => {
  const [classrooms, setClassrooms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchClassrooms = async () => {
      try {
        const response = await api.get(`/api/studentfeedback/get_usercourse/${sid}`);
        setClassrooms(response.data);
      } catch (error) {
        setError("Failed to fetch classrooms. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    fetchClassrooms();
  }, [sid]);

  const handleViewClassroomFeedback = (userCourseId) => {
    navigate(`/student-feedback/${userCourseId}`);
  };

  if (loading) {
    return <p className="text-gray-600 text-center mt-8">Loading Feedbacks...</p>;
  }

  if (error) {
    return <p className="text-red-500 text-center mt-8">{error}</p>;
  }

  return (
    <div className="container mx-auto mt-8">
      <h1 className="text-2xl font-bold text-center mb-6">Student Feedback</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {classrooms.length > 0 ? (
          classrooms.map((classroom) => (
            <div
              key={classroom.usercourse_id}
              className="bg-white shadow-md rounded-lg p-6 hover:shadow-xl transition-shadow duration-300"
            >
              <h3 className="text-xl font-bold text-gray-800 mb-2">
                {classroom.course_name}
              </h3>
              <p className="text-gray-600 mb-2">Semester: {classroom.semester}</p>
              <p className="text-gray-600 mb-2">
                Academic Year: {classroom.academic_year}
              </p>
              <p className="text-gray-600 mb-4">
                Total Questions: {classroom.total_questions}
              </p>
              <button
                className="bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700 transition-colors duration-200"
                onClick={() => handleViewClassroomFeedback(classroom.usercourse_id)}
              >
                View Feedback
              </button>
            </div>
          ))
        ) : (
          <p className="text-gray-600">No Feedback available.</p>
        )}
      </div>
    </div>
  );
};

export default StudentFeedback;
